/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 *
 * @export
 * @interface PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant
 */
export interface PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant {
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant
   */
  protocol: SingleTurnChatProtocolEnum;
  /**
   *
   * @type {number}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant
   */
  name?: string | null;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {CredentialRead}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant
   */
  assistantId: string;
  /**
   *
   * @type {string}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant
   */
  assistantEndpoint: string;
  /**
   *
   * @type {string}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant
   */
  assistantApiVersion: string;
}

/**
 * Check if a given object implements the PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant interface.
 */
export function instanceOfPatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant(
  value: object,
): value is PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('assistantId' in value) || value['assistantId'] === undefined) return false;
  if (!('assistantEndpoint' in value) || value['assistantEndpoint'] === undefined) return false;
  if (!('assistantApiVersion' in value) || value['assistantApiVersion'] === undefined) return false;
  return true;
}

export function PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistantFromJSON(
  json: any,
): PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant {
  return PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistantFromJSONTyped(
    json,
    false,
  );
}

export function PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistantFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant {
  if (json == null) {
    return json;
  }
  return {
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    assistantId: json['assistant_id'],
    assistantEndpoint: json['assistant_endpoint'],
    assistantApiVersion: json['assistant_api_version'],
  };
}

export function PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistantToJSON(
  value?: Omit<
    PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant,
    'id' | 'credential'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
    name: value['name'],
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    assistant_id: value['assistantId'],
    assistant_endpoint: value['assistantEndpoint'],
    assistant_api_version: value['assistantApiVersion'],
  };
}
